<template>
  <div class="nav-wrapper" ref="navWrapper" :class="routeName">
    <div class="login-wrapper pc">
      <div class="login">
        <div class="login-left">
          <p>您好，欢迎来到 MPD AI驱动创新峰会</p>
          <div class="login-button" v-if="!logined">
            <span @click="login()">登录</span>
            <div>/</div>
            <span class="register" @click="register">注册</span>
          </div>
          <slot v-else>
            <span>{{ userName }}</span>
            <span class="vip" v-if="isv">vip</span>
          </slot>
        </div>
        <div class="login-right" v-if="logined">
          <!-- <a @click="openVip" v-if="!isv">成为会员</a> -->
          <a @click="goUserCenter">用户中心</a>
          <a @click="quit">退出</a>
        </div>
      </div>
    </div>
    <div class="pc-wrapper pc" ref="navPc" :style="path_name!=-1 ? 'background:#15151A;' : ''">
      <div class="nav" :style="path_name != -1 ? 'background:#15151A;' : ''">
        <router-link class="logo-wrapper" :to="formatHref('/home')">
          <img src="../assets/img/logo.png"/>
        </router-link>
        <el-row class="nav-bar" :class="global.area_id==='4288'?'simple':''">
          <router-link class="nav-item" :to="formatHref('/home')" :style="path_name!=-1 ? 'color:#FFFFFF;' : ''">首页</router-link>
          <!-- <router-link class="nav-item" :to="formatHref('/live_schedule')" :style="path_name!=-1 ? 'color:#FFFFFF;' : 'color:#FF0000;'" v-if="global.config[global.area_id].haslive">大会直播</router-link> -->
          <router-link class="nav-item" :to="formatHref('/case')" :style="path_name!=-1 ? 'color:#FFFFFF;' : ''">精选案例</router-link>
          <router-link class="nav-item" :to="formatHref('/schedule')" :style="path_name!=-1 ? 'color:#FFFFFF;' : ''">大会日程</router-link>
          <router-link class="nav-item" :to="formatHref('/subject-list')" :style="path_name!=-1 ? 'color:#FFFFFF;' : ''" v-if="global.area_id!=='4288'">演讲专题</router-link>
          <router-link class="nav-item" :to="formatHref('/experts')" :style="path_name!=-1 ? 'color:#FFFFFF;' : ''">演讲嘉宾</router-link>
          <router-link class="nav-item" :to="formatHref('/review')" :style="path_name!=-1 ? 'color:#FFFFFF;' : ''">往期回顾</router-link>
          <!-- <a class="nav-item" v-if="global.config[global.area_id]['collect_case']" :href="global.config[global.area_id]['collect_case']" target="_blank">案例征集</a> -->
          <!-- <a class="nav-item" v-if="global.config[global.area_id]['collect_producer']" :href="global.config[global.area_id]['collect_producer']" target="_blank">出品人邀请</a> -->
          <a class="nav-item" :href="guideArea" target="_blank" @click.prevent="aHandleClick">参会指南</a>
        </el-row>
        <router-link class="buy-ticket" :to="formatHref('/order')" v-if="checkTime()">立即报名</router-link>
        <a class="buy-ticket" v-else v-html="newSession"></a>
      </div>
    </div>
    <!-- 54px -->
    <div class="navigation mob" ref="navMob" :style="`height: ${global.header_height_mob}px;`">
      <div class="dropdown-wrapper" ref="navDrop" @click="(open = false), (open_ = false)">
        <el-dropdown trigger="click">
          <span class="el-dropdown-link">
            <!-- <i class="el-icon-arrow-down el-icon-menu" style="width:50px;height:50px;"></i> -->
            <img class="menu m_le" src="../assets/img/user-icon.png" />
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="!logined">
              <a class="nav-item" @click="login()">登录</a>
            </el-dropdown-item>
            <slot v-else>
              <el-dropdown-item>
                <a class="nav-item" @click="goUserCenter(0)">我的门票</a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a class="nav-item" @click="goUserCenter(1)">我的订单</a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a class="nav-item" @click="goUserCenter(4)">我的收藏</a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a class="nav-item" @click="goUserCenter(2)">个人设置</a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a class="nav-item" @click="quit">退出</a>
              </el-dropdown-item>
            </slot>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <router-link class="logo-wrapper" :to="formatHref('/home')" ref="navLogo">
        <img src="../assets/img/logo.png" />
      </router-link>
      <div
        style="display: flex; display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; align-items: center"
        @click="(open = !open), (open_ = false)"
      >
        <img class="menu" src="../assets/img/header-menu.png" />
      </div>
      <!-- ->backup -->
    </div>
    <ul class="header-menu-mob" v-if="open&&!isPcSize">
      <li>
        <router-link :to="formatHref('/home')">首页</router-link>
      </li>
      <!-- <li v-if="global.config[global.area_id].haslive">
        <router-link :to="formatHref('/live_schedule')">大会直播</router-link>
      </li> -->
      <li>
        <router-link :to="formatHref('/case')">精选案例</router-link>
      </li>
      <li>
        <router-link :to="formatHref('/schedule')">大会日程</router-link>
      </li>
      <li v-if="global.area_id!=='4288'">
        <router-link :to="formatHref('/subject-list')">演讲专题</router-link>
      </li>
      <li>
        <router-link :to="formatHref('/experts')">演讲嘉宾</router-link>
      </li>
      <li>
        <router-link :to="formatHref('/review')">往期回顾</router-link>
      </li>
      <li>
        <a :href="guideArea" target="_blank" @click.prevent="aHandleClick">参会指南</a>
      </li>
      <div class="dibiao">
        <span class="glyphicon glyphicon-time"></span>
        <span class="wenz">{{ time }}</span>
        <span class="wenz" style="float: right">{{ address }}</span>
        <span class="glyphicon glyphicon-map-marker" style="float: right"></span>
      </div>
      <div class="morebtn">
        <!-- <a @click="checkUserInfo()" v-if="checkTime()">立即报名</a> -->
        <router-link :to="formatHref('/order')" v-if="checkTime()">立即报名</router-link>
        <a v-else v-html="newSession"></a>
      </div>
    </ul>
  </div>
</template>

<script>
import { mixinScreen, mixinSession } from '../mixin'

export default {
  name: 'Header',
  mixins: [ mixinScreen, mixinSession ],
  props: {
    routeName: String
  },
  data () {
    return {
      thisDay: new Date().getTime(),
      time: '',
      address: '',
      year: '',
      gYear: '',
      endTime: '',
      show3: false,
      show_xial: false,
      show_user: false,
      open: false,
      open_: false,
      token: '',
      logined: false,
      userName: '',
      isv: false,
      path_name: -1,
      guides: {} // 参会指南、展区分布
    }
  },
  computed: {
    newSession () {
      let tag = '已售罄'
      let keys = Object.keys(this.global.config).map(item => parseInt(item))
      keys = keys.sort((a, b) => a - b).reverse()
      let aid = Math.max(keys) || keys[0] || ''
      let year = this.global.config[aid].year || this.gYear
      let city = this.global.config[aid].title || ''
      let address = this.global.config[aid].address || (year + (this.global.config[aid].jieshu || aid))
      let style = 'line-height: 1; color: #fefefe; text-decoration: none; font-size: 20px; font-family: Source Han Sans CN, Source Han Sans CN-Regular; font-weight: 400; text-align: center; letter-spacing: 0px;'
      tag = `<a style="${style}" href="${this.formatHref('/home', {sid: aid, ay: address}, aid)}" target="_blank">前往 ${year}${city ? ('·' + city + '站') : ''}</a>`
      return tag
    },
    guideArea () {
      // console.log('---area：', this.guides['450'])
      return (this.guides['450'] && (this.guides['450'].file || this.guides['450'].content)) || ''
    },
    guidePlace () {
      // console.log('---place：', this.guides['451'])
      return (this.guides['451'] && (this.guides['451'].file || this.guides['451'].content)) || ''
    }
  },
  created () {
    this.$nextTick(() => {
      const aid = this.global.area_id
      this.year = this.global.config[aid].year && this.global.config[aid].year.toString() && this.global.config[aid].year.toString().slice(0, 4)
      this.gYear = this.global.year && this.global.year.toString().slice(0, 4)
      this.guides = {}
      this.getPlace()
      this.getGuides()
      this.getLiveStatus()
      // eslint-disable-next-line no-undef
      $(function () {
        // eslint-disable-next-line no-undef
        $('.dropdown-toggle').dropdown()
      })
    })
  },
  mounted () {
    this.$nextTick(() => {
      this.path_name = window.location.href.indexOf('video_detail')
    })
  },
  watch: {
    $route: {
      handler (to, from) {
        console.log('header ', to, from, window.location.href)
        // if (this.global.IsPC()) {
        if (window.innerWidth > 767) {
          // this.getUserInfo()
          this.updatedUserInfo()
          // this.isVip()
        }
        // this.isVip()
        this.global.isLogined()
        this.logined = this.global.isLogined()
        /* user_center */
        if (window.location.href) {
          if (!window.location.href.includes('/user_center') || !window.location.href.includes('selected=2')) {
            console.log('============ not user center ============')
            if (localStorage.getItem('link_before_complete')) {
              localStorage.removeItem('link_before_complete')
            }
          }
        }
        if (to) {
          if (from && from.path && from.path.length > 1 && to.path !== '/login' && window.localStorage.getItem('linkurl')) {
            window.localStorage.removeItem('linkurl')
          }
          /* nav video_detail */
          if (to.name) {
            this.open = false
            this.open_ = false
            if (to.name !== 'video_detail') {
              this.path_name = -1
            }
          }
        }
      },
      immediate: true,
      deep: true
    },
    isPcSize (_new, _old) {
      // console.log(_new, _old)
      if (_new !== _old) {
        this.open = false
        this.open_ = false
      }
      if (_new === false) {
        // eslint-disable-next-line no-undef
        $('#app').click((e) => {
          // console.log(e.target, $(e.target))
          if (this.open && !checkParentNode(e.target)) {
            this.open = false
            this.open_ = false
          }
        })
        var checkParentNode = (e) => {
          let flag = false
          let base = ''
          let parentNode = ''
          let tagName = ''
          let className = ''
          if (e) {
            // eslint-disable-next-line no-undef
            base = $(e)
            tagName = (base && base[0] && base[0].tagName && base[0].tagName.toLocaleLowerCase()) || ''
            if (tagName && tagName !== '' && tagName !== 'html') {
              className = (base[0] && base[0].className) || ''
              // console.log('--- ', tagName, className)
              if (
                className.includes('header-menu-mob') ||
                className.includes('navigation') ||
                className.includes('menu')
              ) {
                // console.log('--- ', className)
                flag = true
              } else {
                parentNode = (base[0] && base[0].parentNode) || false
                tagName = (parentNode && parentNode.tagName && parentNode.tagName.toLocaleLowerCase()) || ''
                // console.log('>>> ', className, parentNode, tagName)
                if (tagName && tagName !== '' && tagName !== 'html') {
                  return checkParentNode(parentNode)
                }
              }
            }
          }
          return flag
        }
      }
    },
    open (_new, _old) {
      this.$nextTick(() => {
        if (_new) {
          // eslint-disable-next-line no-undef
          $('.page-mob').css({'z-index': '10'})
        } else {
          // eslint-disable-next-line no-undef
          $('.page-mob').css({'z-index': ''})
        }
      })
    }
  },
  methods: {
    checkTime () {
      let flag = false
      let endDay = this.endTime + 24 * 60 * 60 * 1000 * 30
      // let newAreaId = Math.max(...this.global.area_ids)
      // if ((this.thisDay < endDay) || (this.global.area_id >= newAreaId)) {
      if (this.thisDay < endDay) {
        flag = true
      }
      return flag
    },
    getPlace: function () {
      let purl = this.global.urlNew.place + this.global.area_id
      this.$http
        .jsonp(purl)
        .then((res) => {
          return res.json()
        })
        .then((res) => {
          // console.log(res)
          if (res.status === 200 || res.status === '200') {
            this.time =
              this.global.formatTime(res.data.startTime, 'Y.M.D') +
              '~' +
              this.global.formatTime(res.data.endTime, 'D')
            this.address =
              this.global.area_id && this.global.area_id.toString() === '2699' ? '线上' : (
                res.data.address && !res.data.address.includes('未定') ? res.data.address : (
                  (this.global.area_id && this.global.area_id.toString() === '4288' ? '中国·北京' : '中国·上海')
                )
              )
            // this.global.area_id == 2699 ? (this.address = "线上") : ""; // 2021->2022上海站2699改为线上
            if (res.data && res.data.endTime) { // 结束时间
              let timeLen = this.thisDay.toString().length
              if (res.data.endTime.toString().length === timeLen) {
                this.endTime = parseInt(res.data.endTime)
              } else if (res.data.endTime.toString().length < timeLen) {
                let count = timeLen - res.data.endTime.toString().length
                let base = '1'
                for (let i = 0; i < count; i++) {
                  base += '0'
                }
                this.endTime = res.data.endTime * parseInt(base)
              }
            }
          }
        })
    },
    getLiveStatus: function () {
      let url = `${this.global.urlNew.sue['all']}304`
      this.$http.jsonp(url)
        .then((res) => {
          return res.json()
        })
        .then((res) => {
          // console.log(res)
          if ((res.errno === 0 || res.errno === '0') && res.data && res.data[0] && res.data[0].length > 0) {
            for (let live of res.data[0]) {
              if (live.title && live.title.toString() === this.global.area_id.toString()) {
                // 234 开启开幕式以外的直播
                // 233 仅开启开幕式直播
                // 232 开启直播
                if (live.detailType && live.detailType.toString() === '232') {
                  this.global.config[this.global.area_id].haslive = true
                  this.$forceUpdate()
                }
              }
            }
          }
        })
    },
    getGuides: function () {
      let guides = {}
      let url = this.global.urlNew['sue']['all'] + this.global.normalSueIDs['area']
      this.$http.jsonp(url)
        .then((res) => {
          return res.json()
        })
        .then((res) => {
          // console.log('---', this.global.area_id, res && res.data)
          if (res.errno === 0 || res.errno === '0') {
            ((res.data || [])[0] || []).filter(item =>
              item.title && item.title.includes(this.global.area_id) && (item.content || item.file)
            ).forEach(item => {
              item.areaId = this.global.area_id.toString()
              item.title = item.title.split(' ')[1] || ''
              item.content = item.content || ''
              item.file = item.file === '[]' ? '' : item.file
              guides[item.detailType.toString()] = item // '450'-参会指南 '451'-展区分布
            })
            this.guides = guides
            this.$forceUpdate()
            // console.log('---', this.guides)
          }
        })
    },
    aHandleClick (event) {
      const href = event.currentTarget.getAttribute('href')
      // 检查href是否为空或为#
      if (!href || href === '#' || href === '') {
        event.preventDefault() // 阻止跳转
        console.log('Empty href prevented')
        this.$message.closeAll()
        this.$message({ message: '敬请期待', type: 'warning' })
      } else {
        // 正常跳转
        if (event.currentTarget.getAttribute('target') === '_blank') {
          if (typeof window.open === 'function') {
            window.open(href, '_blank')
          } else {
            window.location.href = href
          }
        } else {
          window.location.href = href
        }
      }
    },
    togglePrevious () {
      this.show3 = !this.show3
      event.stopPropagation()
    },
    login (link) {
      this.global.isLogined()
      window.localStorage.removeItem('logins')
      window.localStorage.removeItem('token')
      // let pre_link = link || window.location.href;
      // eslint-disable-next-line camelcase
      let pre_link = link || (window.location.pathname + window.location.search)
      console.log(pre_link)
      window.localStorage.setItem('linkurl', pre_link)
      const lUrl = this.formatHref('/login')
      this.$router.push(lUrl)
    },
    register () {
      // let pre_link = window.location.href;
      // eslint-disable-next-line camelcase
      let pre_link = window.location.pathname + window.location.search
      window.localStorage.setItem('linkurl', pre_link)
      const lUrl = this.formatHref('/login')
      this.$router.push(lUrl)
    },
    quit () {
      window.localStorage.removeItem('logins')
      window.localStorage.removeItem('token')
      this.$nextTick(() => {
        this.logined = false
      })
      const hUrl = this.formatHref('/home')
      this.$router.push(hUrl)
    },
    goUserCenter (act) {
      const token = window.localStorage.getItem('token')
      if (!token || token === null) {
        this.login()
      } else {
        let uUrl = ''
        if (act && [0, 1, 2, 4].includes(parseInt(act))) {
          uUrl = this.formatHref('/user_center', { selected: act })
        } else {
          uUrl = this.formatHref('/user_center')
        }
        this.$router.push(uUrl)
      }
    },
    updatedUserInfo () {
      if (localStorage.getItem('token')) {
        let url = `${this.global.urlNew['getUserSetting']}?token=${localStorage.getItem('token')}`
        this.$http
          .jsonp(url)
          .then((data) => {
            return data.json()
          })
          .then((data) => {
            console.log('header- updatedUserInfo ', data)
            if (data.status === 200 || data.status === '200') {
              this.userName = data.data.name
              this.isVip()
            } else if (data.code === '1001' || data.status === '1011') {
              if (this.logined) {
                this.$message.closeAll()
                this.$message('当前登录状态已过期，请重新登录')
              }
              window.localStorage.removeItem('logins')
              window.localStorage.removeItem('token')
              this.global.isLogined()
              this.logined = this.global.isLogined()
            } else {
              console.log('获取用户信息失败')
            }
          })
      } else {
        console.log('未登录，或登录状态已过期')
      }
    },
    getUserInfo () {
      let url = `${
        this.global.urlNew['getUserSetting']
      }?token=${localStorage.getItem('token')}`
      this.$http
        .jsonp(url)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          // console.log("header- getUserInfo ",data)
          if (data.status === 200 || data.status === '200') {
            this.userName = data.data.name
            this.isVip()
          } else if (data.code === '1001' || data.status === '1011') {
            this.$message.closeAll()
            this.$message('当前登录状态已过期，请重新登录')
            this.login()
          } else {
            console.log('获取用户信息失败')
          }
        })
    },
    isVip () {
      // const url = `${this.global.urlNew['isVip']}?token=${this.token}`;
      const url = `${this.global.urlNew['isVip']}?token=${localStorage.getItem('token')}`
      this.$http
        .jsonp(url)
        .then((data) => {
          return data.json()
        })
        .then((res) => {
          // console.log("header- isVip() ",res)
          if (res.status === 200 || res.status === '200') {
            if (res.data.res === 1) {
              this.isv = true
            } else {
              this.isv = false
            }
          } else if (res.status === '1004') {
            this.login()
          } else {
            console.log('获取失败')
          }
        })
    },
    openMember () {
      // const url = `https://www.msup.com.cn/api/api-common/create-vip-order-of-top?token=${this.token}&goodsId=893`;
      const url = `https://www.msup.com.cn/api/api-common/create-vip-order-of-top?token=${localStorage.getItem('token')}&goodsId=893`
      this.$http
        .jsonp(url)
        .then((data) => {
          return data.json()
        })
        .then((res) => {
          // console.log("header- openMember ",res)
          if (res.status === 200 || res.status === '200') {
            let oldurl = ''
            if (localStorage.getItem('linkurl')) {
              oldurl = localStorage.getItem('linkurl')
              localStorage.removeItem('linkurl')
            } else {
              oldurl = `https://${
                window.location.href.split('/')[2]
              }/home?aid=${this.global.area_id}`
            }
            if (this.global.hashParam['qd']) {
              oldurl += oldurl.indexOf('?') === -1 ? '?qd=' : '&qd='
              oldurl += this.global.hashParam['qd']
            }
            window.location.href = `${this.global.urlNew['payStands']}?order=${
              res.data.orderNumber
            }&refer=${escape(oldurl)}`
          } else {
            console.log('开通失败')
          }
        })
    },
    openVip () {
      // const url = `${this.global.urlNew['isVip']}?token=${this.token}`;
      const url = `${this.global.urlNew['isVip']}?token=${localStorage.getItem('token')}`
      this.$http
        .jsonp(url)
        .then((data) => {
          return data.json()
        })
        .then((res) => {
          // console.log("header- openVip() ",url,res)
          if (res.status === 200 || res.status === '200') {
            localStorage.setItem('linkurl', window.location.href)
            if (res.data.res === 1) {
              this.isv = true
              if (window.confirm('您当前已经是会员了，是否要再次购买会员？')) {
                this.openMember()
              } else {
              }
            } else {
              this.openMember()
            }
          } else if (res.status === '1004') {
            this.login()
          } else {
            console.log('获取失败')
          }
        })
    },
    // 购票跳转前检查登录
    checkToken () {
      const token = window.localStorage.getItem('token')
      if (token === null || !token) {
        // eslint-disable-next-line camelcase
        let pre_link = '/order?'
        // eslint-disable-next-line camelcase
        let pass_arr = this.global.query_pass
        for (let key of Object.keys(this.$route.query)) {
          if (pass_arr.indexOf(key) === -1 && pre_link.indexOf(key) === -1) {
            // eslint-disable-next-line camelcase
            pre_link += `${key}=${this.$route.query[key]}&`
          }
        }
        this.login(pre_link.slice(0, -1))
        return false
      } else {
        this.token = token
        return true
      }
    },
    checkUserInfo () {
      if (this.checkToken()) {
        const url = `${this.global.urlNew['getUserSetting']}?token=${this.token}`
        this.$http
          .jsonp(url)
          .then((data) => {
            return data.json()
          })
          .then((res) => {
            // console.log("header- checkUserInfo",res)
            if (res.status === 200 || res.status === '200') {
              let flag = true
              for (const key in res.data) {
                if (res.data[key] === '') {
                  flag = false
                  if (window.confirm('购票需要您先完善个人信息')) {
                    window.localStorage.setItem('mpdtoOrder', true)
                    this.$router.push(this.formatHref('/user_center', { selected: '2' }))
                  }
                  break
                }
              }
              if (flag) {
                this.$router.push(this.formatHref('/order'))
              }
            } else if (res.code === '1001' || res.status === '1011') {
              this.$message.closeAll()
              this.$message('当前登录状态已过期，请重新登录')
              // eslint-disable-next-line camelcase
              let pre_link = '/order?'
              // eslint-disable-next-line camelcase
              let pass_arr = this.global.query_pass
              for (let key of Object.keys(this.$route.query)) {
                if (pass_arr.indexOf(key) === -1 && pre_link.indexOf(key) === -1) {
                  // eslint-disable-next-line camelcase
                  pre_link += `${key}=${this.$route.query[key]}&`
                }
              }
              this.login(pre_link.slice(0, -1))
            } else {
              console.log('获取用户信息失败')
            }
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-dropdown-menu__item {
  padding: 4px 20px;
  font-size: 18px;
  font-weight: bold;
  font-family: SourceHanSansCN;
  a {
    text-decoration: none;
    color: var(--deep-color);
  }
}
#app {
  .header-menu-mob {
    width: 100%;
    padding-top: 10px;
    position: fixed;
    z-index: 200;
    background-color: #ffffff;
    box-shadow: 0px 0px 1px var(--main-bgcolor);
    li {
      width: 90%;
      height: auto;
      margin: 0 auto;
      background-color: #ffffff;
      border-bottom: 1px solid #e6e6e6;
      a {
        display: inline-block;
        width: 100%;
        font-size: 18px;
        line-height: 20px;
        color: #000000;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 0;
      }
      a.bef {
        transition: all 0.6s;
      }
      // a.bef:visited,
      a.bef:focus,
      a.bef:hover {
        color: #1377da;
      }
      ul {
        margin-bottom: 5px;
        li {
          padding: 5px 0;
          a {
            padding: 5px 15px 5px 25px;
          }
        }
      }
    }
    .morebtn {
      margin-bottom: 35px !important;
    }
  }

  .login-wrapper {
    width: 100%;
    height: 30px;
    background: #f3f3f3;
    position: fixed;
    z-index: 200;
    top: 0;
    left: 0;
    .login {
      width: 100%;
      // max-width: 1440px;
      // max-width: 1200px;
      max-width: 1260px;
      margin: 0 auto;
      display: -webkit-box;  /* OLD - iOS 6-, Safari 3.1-6 */
      display: -moz-box;     /* OLD - Firefox 19- (buggy but mostly works) */
      display: -ms-flexbox;  /* TWEENER - IE 10 */
      display: -webkit-flex; /* NEW - Chrome */
      display: flex;
      justify-content: space-between;
      // color: #ffffff;
      color: #666666;
      .login-right {
        margin-right: 10px;
        a {
          height: 30px;
          line-height: 30px;
          color: #666666;
          margin-left: 15px;
          font-size: 12px;
          font-weight: 500;
        }
        a:hover {
          // color: rgba(0, 138, 255, 1)
          color: #008aff;
        }
      }
      .login-left {
        display: -webkit-box;  /* OLD - iOS 6-, Safari 3.1-6 */
        display: -moz-box;     /* OLD - Firefox 19- (buggy but mostly works) */
        display: -ms-flexbox;  /* TWEENER - IE 10 */
        display: -webkit-flex; /* NEW - Chrome */
        display: flex;
        p {
          height: 30px;
          display: inline-block;
          line-height: 30px;
          font-size: 12px;
          font-weight: 500;
        }
        span {
          height: 30px;
          font-size: 12px;
          font-weight: 500;
          margin-left: 15px;
          // color: rgba(0, 138, 255, 1)
          color: #008aff;
          line-height: 30px;
          cursor: url("../assets/img/images/mouse3.png"), auto;
        }
        span.vip {
          margin-left: 6px;
        }
        .register {
          margin-left: 0;
        }
      }
      .login-button {
        div {
          // color: rgba(0, 138, 255, 1)
          color: #008aff;
          display: inline;
        }
      }
    }
  }

  // #f3f3f3
  .pc-wrapper.pc, .navigation.mob {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 200;
    background-color: #ffffff;
    box-shadow: 0px 1px 0px #e7e7e7;
  }
  .pc-wrapper {
    height: calc(var(--header-height-pc) - 30px);
    margin-top: 30px;
    // padding: 0 50px;
    // box-shadow: 0px 2px 4px 0px rgba(6, 51, 77, 0.08)
    .nav {
      width: 100%;
      // max-width: 1440px;
      // max-width: 1200px;
      max-width: 1260px;
      margin: 0 auto;
      background: #ffffff;
      display: -webkit-box;  /* OLD - iOS 6-, Safari 3.1-6 */
      display: -moz-box;     /* OLD - Firefox 19- (buggy but mostly works) */
      display: -ms-flexbox;  /* TWEENER - IE 10 */
      display: -webkit-flex; /* NEW - Chrome */
      display: flex;
      justify-content: center;
      align-items: center;
      -webkit-box-flex: 1; /* OLD - iOS 6-, Safari 3.1-6 */
      -moz-box-flex: 1;    /* OLD - Firefox 19- */
      // width: 20%;          /* For old syntax, otherwise collapses. */
      -webkit-flex: 1;     /* Chrome */
      -ms-flex: 1;         /* IE 10 */
      flex: 1;             /* NEW, Spec - Opera 12.1, Firefox 20+ */
      flex-wrap: nowrap;
      .logo-wrapper {
        display: -webkit-box;  /* OLD - iOS 6-, Safari 3.1-6 */
        display: -moz-box;     /* OLD - Firefox 19- (buggy but mostly works) */
        display: -ms-flexbox;  /* TWEENER - IE 10 */
        display: -webkit-flex; /* NEW - Chrome */
        display: flex;
        align-items: center;
        position: relative;
        &::before {
          content: '';
          display: block;
          position: absolute;
          left: 1px;
          right: 1px;
          top: 1px;
          bottom: 1px;
          z-index: 2;
          background-color: var(--main-bgcolor);
        }
        img {
          max-width: 100%;
          max-height: 64px;
          height: calc(var(--header-height-pc) - 30px);
          position: relative;
          z-index: 3;
          // background-color: var(--main-bgcolor);
        }
      }
      .nav-bar {
        width: 100%;
        display: -webkit-box;  /* OLD - iOS 6-, Safari 3.1-6 */
        display: -moz-box;     /* OLD - Firefox 19- (buggy but mostly works) */
        display: -ms-flexbox;  /* TWEENER - IE 10 */
        display: -webkit-flex; /* NEW - Chrome */
        display: flex;
        justify-content: space-between;
        align-items: center;
        -webkit-box-flex: 1; /* OLD - iOS 6-, Safari 3.1-6 */
        -moz-box-flex: 1;    /* OLD - Firefox 19- */
        // width: 20%;          /* For old syntax, otherwise collapses. */
        -webkit-flex: 1;     /* Chrome */
        -ms-flex: 1;         /* IE 10 */
        flex: 1;             /* NEW, Spec - Opera 12.1, Firefox 20+ */
        flex-wrap: nowrap;
        // ul {
        //   display: contents;
        // }
        .nav-item {
          height: calc(var(--header-height-pc) - 30px);
          line-height: calc(var(--header-height-pc) - 30px);
          text-decoration: none;
          padding: 0;
          font-size: 18px;
          font-weight: 500;
          font-family: Source Han Sans CN;
          white-space: nowrap;
          color: #01255e;
        }
        .dropdown-menu > li > a {
          height: 30px !important;
          line-height: 30px !important;
          color: #01255e !important;
          font-size: 18px !important;
          font-weight: bold !important;
          padding: 0 10px !important;
        }
        .to-previous {
          text-decoration: none;
          padding: 59px 20px 41px;
          font-size: 18px;
          font-weight: bold;
          font-family: SourceHanSansCN, SourceHanSansCN-Medium;
          color: var(--deep-color)
        }
        &.simple {
          &::before {
            content: '返回首页';
            display: block;
            height: 100px;
            line-height: 100px;
            font-size: 18px;
            opacity: 0;
          }
          // justify-content: space-evenly;
          // justify-content: flex-end;
          // .nav-item {
          //   margin: 0 30px;
          // }
        }
      }
      .buy-ticket,
      .buy-ticket *,
      .buy-ticket *:focus,
      .buy-ticket *:hover,
      .buy-ticket *:visited {
        line-height: 1;
        color: #fefefe;
        text-decoration: none;
        font-size: 20px;
        font-family: Source Han Sans CN, Source Han Sans CN-Regular;
        font-weight: 400;
        text-align: center;
        letter-spacing: 0px;
      }
      .buy-ticket {
        // margin: 28px 10px 20px 0;
        // margin: 0 10px 0 0;
        padding-left: 12px;
        padding-right: 12px;
        // width: 130px;
        // height: 45px;
        width: fit-content;
        min-width: 130px;
        height: fit-content;
        min-height: 45px;
        // line-height: 45px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: var(--main-bgcolor);
        // background: var(--deep-color);
        // color: #fefefe;
        border-radius: 50px;
        outline: none;
        border: none;
        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
  @media (min-width: 1200px) {
    .nav-bar {
      // margin-right: 308px;
      margin-left: 308px;
    }
  }
  // @media (max-width: 1023px) {
  @media (max-width: 767px) {
    .pc {
      display: none;
    }
    .mob {
      display: -webkit-box;  /* OLD - iOS 6-, Safari 3.1-6 */
      display: -moz-box;     /* OLD - Firefox 19- (buggy but mostly works) */
      display: -ms-flexbox;  /* TWEENER - IE 10 */
      display: -webkit-flex; /* NEW - Chrome */
      display: flex;
    }
    // .Live.nav-wrapper {
    //   display: none;
    // }
    .navigation {
      padding: 0 6vw;
      white-space: nowrap;
      justify-content: space-between;
      // border: 1px solid #e7e7e7;
      .logo-wrapper {
        position: relative;
        &::before {
          content: '';
          display: block;
          position: absolute;
          left: 1px;
          right: 1px;
          top: 7px;
          bottom: 7px;
          z-index: 2;
          background-color: var(--main-bgcolor);
        }
        img {
          width: auto;
          height: 50px;
          margin-top: 5px;
          margin-bottom: 5px;
          position: relative;
          z-index: 3;
        }
      }
    }
    .dibiao {
      // width: 80%;
      width: 88%;
      margin: 0 auto;
      margin-top: 35px;
      margin-bottom: 20px;
      span {
        color: #000000;
      }
    }
    .morebtn {
      width: 90%;
      margin-bottom: 20px !important;
      a {
        font-size: 14px;
      }
    }
    .dropdown-wrapper {
      display: -webkit-box;  /* OLD - iOS 6-, Safari 3.1-6 */
      display: -moz-box;     /* OLD - Firefox 19- (buggy but mostly works) */
      display: -ms-flexbox;  /* TWEENER - IE 10 */
      display: -webkit-flex; /* NEW - Chrome */
      display: flex;
      align-items: center;
    }
    .el-dropdown {
      .menu {
        max-width: 90%;
      }
      .menu.m_le {
        max-width: 80%;
      }
      .el-dropdown-link {
        .el-icon-arrow-down.el-icon-menu {
          width: 100%;
          height: 100%;
        }
      }
    }
    .el-dropdown-menu {
      width: 100vw;
      left: 0 !important;
      .el-dropdown-menu__item {
        width: 90%;
        margin: 0 auto;
        padding: 10px 0;
        border-bottom: 1px solid #e6e6e6;
        color: #000000;
        font-weight: 400;
        .url-list {
          div {
            padding-left: 4vw;
            border-bottom: 1px solid #e6e6e6;
          }
        }
        a {
          color: #000000;
          display: block;
          line-height: 20px;
        }
      }
      .el-dropdown-menu__item:focus,
      .el-dropdown-menu__item:not(.is-disabled):hover {
        background-color: inherit;
        color: inherit;
      }

      .el-popper .popper__arrow {
        display: none;
      }
    }
  }
  @media (min-width: 1023px) {
    .pc {
      display: -webkit-box;  /* OLD - iOS 6-, Safari 3.1-6 */
      display: -moz-box;     /* OLD - Firefox 19- (buggy but mostly works) */
      display: -ms-flexbox;  /* TWEENER - IE 10 */
      display: -webkit-flex; /* NEW - Chrome */
      display: flex;
    }
    .mob {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/componentsNew/Header.vue